module.exports = __webpack_public_path__ + "img/intro3.592da201.png";